import { Flex, Box } from "@chakra-ui/react";

import InfoCard from "@components/InfoCard";
import Icon from "@components/Icon";

import { InfoCardBody, TextPrimary, TextSecondary } from "theme";

// assets
import { RightArrow } from "icons";

interface DashboardCardProps {
  title?: string;
  xToken: string;
  erc20Token: string;
  xTokens: string;
  erc20Tokens: string;
  erc20TokensMarketValue: string;
  exchangeRate: string;
}

const DashboardCard = ({
  title,
  xToken,
  erc20Token,
  xTokens,
  erc20Tokens,
  erc20TokensMarketValue,
  exchangeRate,
}: DashboardCardProps) => {
  return (
    <InfoCard title={title}>
      <InfoCardBody>
        <Flex alignItems="center" justifyContent="space-between">
          <Flex flexDirection="column" justifyContent="center">
            <TextSecondary fontWeight="400" fontSize="12px" lineHeight="18px">
              You have
            </TextSecondary>
            <TextPrimary
              mt="4px"
              fontWeight="600"
              fontSize="20px"
              lineHeight="24px"
            >
              {xTokens} {xToken}
            </TextPrimary>
            <Flex mt="4px" fontWeight="400" fontSize="12px" lineHeight="18px">
              <TextSecondary>{`1 ${xToken} = `}</TextSecondary>
              <TextPrimary display="inline-block" ml="4px">
                {exchangeRate}
              </TextPrimary>
              <TextSecondary ml="4px"> {erc20Token}</TextSecondary>
            </Flex>
          </Flex>

          <Box h-="24px" w="24px">
            <Icon
              width="100%"
              height="100%"
              Icon={RightArrow}
              color="textInput"
            />
          </Box>

          <Flex
            flexDirection="column"
            justifyContent="center"
            ml="16px"
            minW="84px"
          >
            <TextSecondary fontWeight="400" fontSize="12px" lineHeight="18px">
              You will get
            </TextSecondary>
            <TextPrimary
              mt="4px"
              fontWeight="600"
              fontSize="20px"
              lineHeight="24px"
            >
              {erc20Tokens} {erc20Token}
            </TextPrimary>
            <Box mt="4px" fontWeight="400" fontSize="12px" lineHeight="18px">
              <TextSecondary>${erc20TokensMarketValue}</TextSecondary>
            </Box>
          </Flex>
        </Flex>
      </InfoCardBody>
    </InfoCard>
  );
};

export default DashboardCard;
